import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';

$(document).ready(function () {
    // Show/hide plus/minus icon when clicking on a question
    $('[id^="heading"]').click(function () {
        if ($(this).find('i').hasClass('fa-angle-down')) {
            $(this).find('i').removeClass('fa-angle-down').addClass('fa-angle-right');
        } else {
            $(this).find('i').removeClass('fa-angle-right').addClass('fa-angle-down');
        }
    });
});